import { gql } from '@apollo/client'

export const ROLE_GENERATE_MUTATION = gql`
  mutation GenerateRole($input: RoleInput!) {
    generateRole(input: $input) {
      message
    }
  }
`
export const ROLE_MODIFY_MUTATION = gql`
  mutation ModifyRole($roleID: String!, $accessess: AccessessInput!) {
    modifyRole(roleID: $roleID, accessess: $accessess) {
      message
    }
  }
`

export const ROLE_DELETE_MUTATION = gql`
  mutation DeleteRole($roleID: String!) {
    deleteRole(roleID: $roleID) {
      message
    }
  }
`
